<script>
  import LazyLoadedTabContent from '../../components/LazyLoadedTabContent.svelte';
  import TabsWithRouting from '../../components/TabsWithRouting.svelte';

  import DataFeedInventory from './DataFeedInventory.svelte';
  import RestoreHistory from './restore-service/RestoreHistory.svelte';
  import ServiceStatusList from './service-state/ServiceStatusList.svelte';
  import SlaTaskList from './sla/SlaTaskList.svelte';
  import Venues from './Venues.svelte';
</script>

<TabsWithRouting
  defaultHash="#data-inventory"
  tabsWrapperProps={{ 'aria-label': 'Data Feed module tabs' }}
  tabs={[
    { label: 'Data Feeds', hash: '#data-inventory' },
    { label: 'Venues', hash: '#venues' },
    { label: 'SLA Tasks', hash: '#sla' },
    { label: 'Service Status', hash: '#service-status' },
    { label: 'Object Restore', hash: '#object-restore' },
  ]}
>
  <LazyLoadedTabContent hash="#data-inventory"><DataFeedInventory /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#venues"><Venues /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#sla"><SlaTaskList /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#service-status"><ServiceStatusList /></LazyLoadedTabContent>
  <LazyLoadedTabContent hash="#object-restore"><RestoreHistory /></LazyLoadedTabContent>
</TabsWithRouting>
